const pop = () => {
    const buttons = document.querySelectorAll('.doctor-container button.button');
    const popups = document.querySelectorAll('.popup');
  
    const closePopups = () => {
      for (let i = 0; i < popups.length; i++) {
        popups[i].classList.remove('active');
      }
    };
  
    const handlePopup = (elem) => {
      closePopups();
      elem.parentNode.querySelector('.popup').classList.add('active');
    };
  
    window.onclick = (e) => {
      for (let i = 0; i < popups.length; i++) {
        if (e.target === popups[i] || popups[i].contains(e.target) || e.target === buttons[i]) {
          return;
        }
      }
      closePopups();
    };
  
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].onclick = (e) => {
        handlePopup(e.target);
      };
    }
  };
  
  export default pop;
  